import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarsComponent, Person, TooltipModule } from '@libs/ui-lib';
import { TranslateModule } from '@ngx-translate/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { PhoneFormatPipe } from '@libs/patients';
import { PatientContact, PatientContactTypeEnum } from '@ffd/api-client';
import { FullNamePipe, AgePipe } from '../../pipes';
import { HealthHistoryPatientDetailsItemComponent } from '../health-history-patient-details/components/health-history-patient-details-item/health-history-patient-details-item.component';

export interface HealthHistoryPatientDetailsPreviewVM {
  lastName: string;
  firstName: string;
  middleName?: string;
  birthDate?: string;
  homePhone?: string;
  mobilePhone?: string;
  id?: string;
  userId?: string;
  avatarUrl?: string | null;
  email?: string;
  isGlobalAdmin?: boolean;
  contacts: Array<PatientContact>;
}

@Component({
  selector: 'lib-health-history-patient-details-preview',
  standalone: true,
  imports: [
    CommonModule,
    FullNamePipe,
    AvatarsComponent,
    TranslateModule,
    TooltipModule,
    AgePipe,
    CdkAccordionModule,
    HealthHistoryPatientDetailsItemComponent,
    PhoneFormatPipe,
  ],
  templateUrl: './health-history-patient-details-preview.component.html',
  styleUrl: './health-history-patient-details-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthHistoryPatientDetailsPreviewComponent {
  public readonly patient = input.required<HealthHistoryPatientDetailsPreviewVM>();
  protected readonly patientAvatar = computed(() => this.patient() as Person);

  public getContactLabelKey(type: PatientContactTypeEnum | undefined): string {
    switch (type) {
      case PatientContactTypeEnum.EMERGENCY_CONTACT: {
        return 'health_history_patient_secondary_emergency_contact';
      }
      case PatientContactTypeEnum.PREFERRED_PHARMACY: {
        return 'health_history_patient_secondary_pharmacy';
      }
      case PatientContactTypeEnum.PHYSICIAN_CONTACT: {
        return 'health_history_patient_secondary_physician';
      }
      default: {
        return '';
      }
    }
  }
}
